import { Wrapper } from "./styled";

const FieldWrapper = ({ children, ...restProps }) => (
  <Wrapper {...restProps}>{children}</Wrapper>
);

export default FieldWrapper;
